export enum CourseNotificationChannel {
    PUSH = 'PUSH',
    EMAIL = 'EMAIL',
    WEBAPP = 'WEBAPP',
}
